import React from 'react';

export function StepLocationLabel() {
  return (
    <>
      Nová provozovna - <b>Adresa, Poloha</b>
    </>
  );
}
